import type { Theme } from '@mentimeter/http-clients';
import {
  OverviewListItemWrapper,
  type OverviewListItemType,
  OverviewListStyleWrapper,
} from '@mentimeter/editor-overview-ui';
import { useDeviceChecker } from '@mentimeter/ragnar-device';
import { useKeyboardHandler } from '@mentimeter/editor-essentials/utils';

export const OverviewListViewOnly = ({
  seriesTheme,
  activeQuestionId,
  overviewListItems,
  userIsCommentCollaborator,
  compactMode,
  onClickSlideThumbnail,
  onClickCommentIcon,
}: {
  seriesTheme: Theme;
  activeQuestionId: string;
  overviewListItems: OverviewListItemType[];
  userIsCommentCollaborator: boolean;
  compactMode: boolean;
  onClickSlideThumbnail: (slideId: string) => void;
  onClickCommentIcon: () => void;
}) => {
  const { isSmallDevice: mobile } = useDeviceChecker();
  useKeyboardHandler();

  return (
    <OverviewListStyleWrapper compactMode={compactMode}>
      {overviewListItems.map((item, index) => (
        <OverviewListItemWrapper
          key={item.id}
          active={item.id === activeQuestionId}
          index={index}
          item={item}
          mobile={mobile}
          selected={false}
          theme={seriesTheme}
          onClick={(_e, itemId) => {
            onClickSlideThumbnail(itemId);
          }}
          compactMode={compactMode}
          userIsCommentCollaborator={userIsCommentCollaborator}
          onClickCommentIcon={onClickCommentIcon}
        />
      ))}
    </OverviewListStyleWrapper>
  );
};
